import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';

var SelectInputWrap = styled.div(function (_a) {
    var hasError = _a.hasError, disabled = _a.disabled;
    var borderColor = tokens.color.airJordan[400];
    if (hasError) {
        borderColor = tokens.color.roshe[600];
    }
    else if (disabled) {
        borderColor = "transparent";
    }
    var backgroundColor = disabled
        ? tokens.color.superstar.p
        : tokens.color.yeezy[0];
    var color = disabled
        ? tokens.color.airJordan[400]
        : tokens.color.airJordan.p;
    return {
        flexGrow: 1,
        flexBasis: 0,
        select: {
            width: "100%",
            border: "".concat(tokens.borderWidth.xs, " solid ").concat(borderColor),
            backgroundColor: backgroundColor,
            borderRadius: tokens.borderRadius.m,
            fontFamily: tokens.fontFamilies.primary,
            fontSize: tokens.fontSize[3],
            height: "56px",
            color: color,
            pointerEvents: disabled ? "none" : "initial",
            "&:focus": {
                outline: "none",
                borderColor: hasError
                    ? tokens.color.roshe[600]
                    : tokens.color.airJordan[600],
            },
        },
    };
});

export { SelectInputWrap };
//# sourceMappingURL=SelectInput.styles.js.map
